<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="80%"
      :wrapperClosable="false"
      v-if="!isLog"
    >
      <div class="form-center" v-loading="loading">
        <el-form
          :model="form"
          ref="form"
          label-width="120px"
          :rules="rules"
          :disabled="disabled"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="工单编号">
                <el-input
                  v-model="form.Code"
                  placeholder="系统自动生成"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="设备名称" prop="DeviceItemName">
                <div style="width: 100%; display: flex; align-items: center">
                  <el-input
                    v-model="form.DeviceItemNameJson"
                    placeholder="请选择设备"
                    disabled
                    style="width: calc(100% - 60px)"
                  ></el-input>
                  <el-button
                    style="width: 60px"
                    type="primary"
                    :disabled="devInfo.Id || disabled ? true : false"
                    @click="openDevice"
                    ><i class="el-icon-search"></i
                  ></el-button>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工单类型" prop="WorkOrderType">
                <SelectDicValue
                  code="WorkOrderType"
                  disabled
                  @change=";(form.Type = ''), (form.FaultDescription = '')"
                  v-model="form.WorkOrderType"
                ></SelectDicValue>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-show="form.WorkOrderType === '0'">
              <!-- //巡检类型 0 -->
              <el-form-item label="类型" prop="Type">
                <SelectDicValue
                  code="InspectionType"
                  v-model="form.Type"
                ></SelectDicValue>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-show="form.WorkOrderType === '1'">
              <!-- //保养类型 1 -->
              <el-form-item label="类型" prop="Type">
                <SelectDicValue
                  code="MaintenanceLevel"
                  v-model="form.Type"
                ></SelectDicValue>
              </el-form-item>
            </el-col>
            <el-col
              :span="8"
              v-show="form.WorkOrderType === '2' || form.WorkOrderType === '3'"
            >
              <!-- //维修类型 2-->
              <el-form-item label="类型" prop="Type">
                <SelectDicValue
                  code="TheFaultType"
                  v-model="form.Type"
                ></SelectDicValue>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="供应商"
                prop="Amount"
                v-if="form.WorkOrderType === '3'"
              >
                <el-input
                  v-model="form.SupplierName"
                  placeholder="请选择供应商"
                  disabled
                  style="width: calc(100% - 60px)"
                ></el-input>
                <el-button
                  style="width: 60px"
                  type="primary"
                  :disabled="disabled"
                  @click="openSup"
                  ><i class="el-icon-search"></i
                ></el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="合同编号"
                prop="Contract"
                v-if="form.WorkOrderType === '3'"
              >
                <el-input
                  v-model="form.Contract"
                  type="number"
                  :disabled="disabled"
                  :controls="false"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="费用"
                prop="Amount"
                v-if="form.WorkOrderType === '3'"
              >
                <el-input
                  v-model="form.Amount"
                  type="number"
                  :disabled="disabled"
                  :controls="false"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="人员信息" prop="OperatorIds">
                <SelectData
                  v-model="form.OperatorIds"
                  multiple
                  url="/Base_Manage/Base_User/GetDataList"
                  :option="{
                    label: 'RealName',
                    Id: 'Id',
                  }"
                ></SelectData>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工单日期" prop="WorkOrderDate">
                <el-date-picker
                  v-model="form.WorkOrderDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 100%"
                  placeholder="请选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预计完成日期" prop="ExpectDate">
                <el-date-picker
                  v-model="form.ExpectDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 100%"
                  placeholder="请选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="16" v-if="form.WorkOrderType === '3'">
              <el-form-item label="备注">
                <el-input
                  v-model="form.Annotation"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="图片" prop="HeadImg" class="Describe">
                <el-upload
                  :action="
                    $rootUrl +
                    `/Base_Manage/Upload/ProjectOssUploadFileByForm?type=6`
                  "
                  :headers="{
                    Authorization: token,
                  }"
                  :file-list="Imgs"
                  :limit="5"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-success="handleAvatarSuccess"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                  :before-upload="beforeAvatarUpload"
                  :disabled="disabled"
                >
                  <i class="el-icon-plus" v-if="!disabled"></i>
                  <i class="el-icon-close" v-if="disabled"></i>
                  <!-- <el-image
                v-if="form.HeadImg"
                fit="contain"
                class="HeadImg"
                :src="form.HeadImg"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-collapse v-model="activeNames">
            <el-collapse-item
              title="故障描述"
              name="1"
              v-if="form.WorkOrderType === '2' || form.WorkOrderType === '3'"
            >
              <template slot="title">
                <span style="color: #f56c6c">*</span>&nbsp;故障描述 &nbsp;&nbsp;
              </template>
              <el-row>
                <el-col
                  :span="24"
                  v-if="
                    form.WorkOrderType === '2' || form.WorkOrderType === '3'
                  "
                >
                  <!-- <el-button
                    type="primary"
                    style="
                      border-radius: 10px;
                      font-size: 14px;
                      margin-left: 120px;
                      margin-bottom: 10px;
                    "
                    @click="AIOpen"
                    ><i class="el-icon-chat-dot-round"></i>AI建议</el-button
                  > -->
                  <!-- //维修类型 2-->
                  <el-form-item label=" " prop="FaultDescription">
                    <el-input
                      v-model="form.FaultDescription"
                      placeholder=""
                      type="textarea"
                      rows="10"
                      resize="none"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>

            <el-collapse-item title="建议描述" name="2">
              <template slot="title">
                <span style="color: #f56c6c">*</span>&nbsp;建议描述
              </template>
              <el-row style="padding-bottom: 50px">
                <el-form-item label=" " prop="Remarks" style="margin-bottom: 0">
                  <quill-editor
                    ref="myQuillEditor"
                    v-model="form.Remarks"
                    :options="editorOption"
                    v-if="!disabled"
                    style="height: 600px"
                  />
                  <div
                    v-html="form.Remarks"
                    v-if="disabled"
                    style="
                      width: 100%;
                      height: 600px;
                      overflow: auto;
                      border: 1px solid #e2e2e2;
                      padding: 10px;
                      background-color: #f5f7fa;
                    "
                  ></div>

                  <!-- <el-input
                  v-model="form.Remarks"
                  placeholder=""
                  type="textarea"
                  rows="3"
                  resize="none"
                ></el-input> -->
                </el-form-item>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="备件信息" name="3">
              <el-row>
                <div style="line-height: 30px">
                  <el-button type="primary" @click="addList" v-if="!disabled"
                    >添加备件</el-button
                  >
                </div>
                <el-table
                  :data="MaterialsData"
                  ref="MaterialsData"
                  style="width: 100%"
                  height="400px"
                >
                  <el-table-column label="序号" width="50" type="index">
                  </el-table-column>

                  <el-table-column
                    label="备件编号"
                    align="center"
                    prop="Code"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="备件名称"
                    align="center"
                    prop="Name"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="备件类型"
                    align="center"
                    prop="MaterialTypeName"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="备件规格"
                    align="center"
                    prop="Spec"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="单位"
                    align="center"
                    prop="storageName"
                    sortable
                  >
                  </el-table-column>

                  <el-table-column
                    label="货位"
                    align="center"
                    prop="LocalName"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="库存数量"
                    align="right"
                    prop="Nums_N"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="数量"
                    align="center"
                    prop="Num"
                    sortable
                  >
                    <template slot-scope="scope">
                      <el-input
                        @input="NumChange($event, scope.row)"
                        v-model="scope.row.Num"
                        :disabled="disabled"
                        type="number"
                        :controls="false"
                        style="width: 100%"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                    prop="op"
                    v-if="!disabled"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        style="color: #f78989"
                        size="mini"
                        @click="MaterialsData.splice(scope.$index, 1)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit" v-if="!disabled"
          >保存</el-button
        >
        <el-button
          @click="handleAudit"
          type="success"
          v-if="title == '提交工单'"
        >
          提交</el-button
        >
      </div>
    </el-drawer>
    <div v-if="isLog && drawer">
      <div v-loading="loading">
        <el-form
          :model="form"
          ref="form"
          label-width="120px"
          :rules="rules"
          :disabled="disabled"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="工单编号">
                <el-input
                  v-model="form.Code"
                  placeholder="系统自动生成"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="设备名称" prop="DeviceItemName">
                <div style="width: 100%; display: flex; align-items: center">
                  <el-input
                    v-model="form.DeviceItemNameJson"
                    placeholder="请选择设备"
                    disabled
                    style="width: calc(100% - 60px)"
                  ></el-input>
                  <el-button
                    style="width: 60px"
                    type="primary"
                    :disabled="devInfo.Id || disabled ? true : false"
                    @click="openDevice"
                    ><i class="el-icon-search"></i
                  ></el-button>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工单类型" prop="WorkOrderType">
                <SelectDicValue
                  code="WorkOrderType"
                  disabled
                  @change=";(form.Type = ''), (form.FaultDescription = '')"
                  v-model="form.WorkOrderType"
                ></SelectDicValue>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-show="form.WorkOrderType === '0'">
              <!-- //巡检类型 0 -->
              <el-form-item label="类型" prop="Type">
                <SelectDicValue
                  code="InspectionType"
                  v-model="form.Type"
                ></SelectDicValue>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-show="form.WorkOrderType === '1'">
              <!-- //保养类型 1 -->
              <el-form-item label="类型" prop="Type">
                <SelectDicValue
                  code="MaintenanceLevel"
                  v-model="form.Type"
                ></SelectDicValue>
              </el-form-item>
            </el-col>
            <el-col
              :span="8"
              v-show="form.WorkOrderType === '2' || form.WorkOrderType === '3'"
            >
              <!-- //维修类型 2-->
              <el-form-item label="类型" prop="Type">
                <SelectDicValue
                  code="TheFaultType"
                  v-model="form.Type"
                ></SelectDicValue>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="供应商"
                prop="Amount"
                v-if="form.WorkOrderType === '3'"
              >
                <el-input
                  v-model="form.SupplierName"
                  placeholder="请选择供应商"
                  disabled
                  style="width: calc(100% - 60px)"
                ></el-input>
                <el-button
                  style="width: 60px"
                  type="primary"
                  :disabled="disabled"
                  @click="openSup"
                  ><i class="el-icon-search"></i
                ></el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="合同编号"
                prop="Contract"
                v-if="form.WorkOrderType === '3'"
              >
                <el-input
                  v-model="form.Contract"
                  type="number"
                  :disabled="disabled"
                  :controls="false"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="费用"
                prop="Amount"
                v-if="form.WorkOrderType === '3'"
              >
                <el-input
                  v-model="form.Amount"
                  type="number"
                  :disabled="disabled"
                  :controls="false"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="人员信息" prop="OperatorIds">
                <SelectData
                  v-model="form.OperatorIds"
                  multiple
                  url="/Base_Manage/Base_User/GetDataList"
                  :option="{
                    label: 'RealName',
                    Id: 'Id',
                  }"
                ></SelectData>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工单日期" prop="WorkOrderDate">
                <el-date-picker
                  v-model="form.WorkOrderDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 100%"
                  placeholder="请选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预计完成日期" prop="ExpectDate">
                <el-date-picker
                  v-model="form.ExpectDate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 100%"
                  placeholder="请选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="备注">
                <el-input
                  v-model="form.Annotation"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="图片" prop="HeadImg" class="Describe">
                <el-upload
                  :action="
                    $rootUrl +
                    `/Base_Manage/Upload/ProjectOssUploadFileByForm?type=6`
                  "
                  :headers="{
                    Authorization: token,
                  }"
                  :file-list="Imgs"
                  :limit="5"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :on-success="handleAvatarSuccess"
                  :on-remove="handleRemove"
                  :on-exceed="handleExceed"
                  :before-upload="beforeAvatarUpload"
                  :disabled="disabled"
                  :class="{ 'disabled-upload': disabled }"
                >
                  <i class="el-icon-plus" v-if="!disabled"></i>
                  <i class="el-icon-close" v-if="disabled"></i>
                  <!-- <el-image
                v-if="form.HeadImg"
                fit="contain"
                class="HeadImg"
                :src="form.HeadImg"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-collapse v-model="activeNames">
            <el-collapse-item
              title="故障描述"
              name="1"
              v-if="form.WorkOrderType === '2' || form.WorkOrderType === '3'"
            >
              <template slot="title">
                <span style="color: #f56c6c">*</span>&nbsp;故障描述 &nbsp;&nbsp;
              </template>
              <el-row>
                <el-col
                  :span="24"
                  v-if="
                    form.WorkOrderType === '2' || form.WorkOrderType === '3'
                  "
                >
                  <!-- <el-button
                    type="primary"
                    style="
                      border-radius: 10px;
                      font-size: 14px;
                      margin-left: 120px;
                      margin-bottom: 10px;
                    "
                    @click="AIOpen"
                    ><i class="el-icon-chat-dot-round"></i>AI建议</el-button
                  > -->
                  <!-- //维修类型 2-->
                  <el-form-item label=" " prop="FaultDescription">
                    <el-input
                      v-model="form.FaultDescription"
                      placeholder=""
                      type="textarea"
                      rows="10"
                      resize="none"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-collapse-item>

            <el-collapse-item title="建议描述" name="2">
              <template slot="title">
                <span style="color: #f56c6c">*</span>&nbsp;建议描述
              </template>
              <el-row style="padding-bottom: 50px">
                <el-form-item label=" " prop="Remarks" style="margin-bottom: 0">
                  <quill-editor
                    ref="myQuillEditor"
                    v-model="form.Remarks"
                    :options="editorOption"
                    v-if="!disabled"
                    style="height: 600px"
                  />
                  <div
                    v-html="form.Remarks"
                    v-if="disabled"
                    style="
                      width: 100%;
                      height: 600px;
                      overflow: auto;
                      border: 1px solid #e2e2e2;
                      padding: 10px;
                      background-color: #f5f7fa;
                    "
                  ></div>

                  <!-- <el-input
                  v-model="form.Remarks"
                  placeholder=""
                  type="textarea"
                  rows="3"
                  resize="none"
                ></el-input> -->
                </el-form-item>
              </el-row>
            </el-collapse-item>
            <el-collapse-item title="备件信息" name="3">
              <el-row>
                <div style="line-height: 30px">
                  <el-button type="primary" @click="addList" v-if="!disabled"
                    >添加备件</el-button
                  >
                </div>
                <el-table
                  :data="MaterialsData"
                  ref="MaterialsData"
                  style="width: 100%"
                  height="400px"
                >
                  <el-table-column label="序号" width="50" type="index">
                  </el-table-column>

                  <el-table-column
                    label="备件编号"
                    align="center"
                    prop="Code"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="备件名称"
                    align="center"
                    prop="Name"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="备件类型"
                    align="center"
                    prop="MaterialTypeName"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="备件规格"
                    align="center"
                    prop="Spec"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="单位"
                    align="center"
                    prop="storageName"
                    sortable
                  >
                  </el-table-column>

                  <el-table-column
                    label="货位"
                    align="center"
                    prop="LocalName"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="库存数量"
                    align="right"
                    prop="Nums_N"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column
                    label="数量"
                    align="center"
                    prop="Num"
                    sortable
                  >
                    <template slot-scope="scope">
                      <el-input
                        @input="NumChange($event, scope.row)"
                        v-model="scope.row.Num"
                        :disabled="disabled"
                        type="number"
                        :controls="false"
                        style="width: 100%"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                    prop="op"
                    v-if="!disabled"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        style="color: #f78989"
                        size="mini"
                        @click="MaterialsData.splice(scope.$index, 1)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </div>
    </div>
    <DevDialog
      ref="DevDialog"
      @select="handleDevSelect"
      type="radio"
    ></DevDialog>

    <FittingsOut ref="FittingsOut" @select="selectFittingsOut"></FittingsOut>
    <AIDrawer ref="AIDrawer" @AI="AISub"></AIDrawer>
    <Supplier ref="Supplier" type="radio" @select="selectSup"></Supplier>
  </div>
</template>
<script>
import FittingsOut from '@/components/Fittings/FittingsOut.vue'

import SelectData from '@/components/SelectData/SelectData.vue'
import SelectDicValue from '@/components/DicValue/SelectDicValue.vue'
import DevDialog from '@/components/DevDialog/DevDialog.vue'
import AIDrawer from '@/components/AIDrawer/AIDrawer.vue'
import Token from '@/utils/cache/TokenCache.js'
import Supplier from '@/components/Supplier/Supplier.vue'
import moment from 'moment'
export default {
  data() {
    return {
      editorOption: {
        theme: 'snow', // 主题
        placeholder: '',
        AIshow: false,
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ header: 1 }, { header: 2 }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ direction: 'rtl' }],
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ['clean', 'link'],
              ['addBtn'],
            ], // 自定义工具栏选项
            handlers: {
              addBtn: () => {
                this.AIOpen()
              },
            },
          },
        },
      },

      title: '',
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      RoleList: [],
      MaterialsData: [],
      form: {
        Code: '',
        DeviceItemId: '',
        DeviceItemName: '',
        DeviceItemNameJson: '',
        DeviceItemCode: '',
        WorkOrderType: '',
        FaultDescription: '',
        Type: '',
        WorkOrderDate: '',
        ExpectDate: '',
        Remarks: '',
        OperatorIds: [],
        Amount: '',
        SupplierId: '',
        SupplierName: '',
      },
      Imgs: [],
      rules: {
        Code: [{ required: true, message: '请输入工单编号', trigger: 'blur' }],
        DeviceItemName: [
          { required: true, message: '请选择设备名称', trigger: 'change' },
        ],
        WorkOrderType: [
          { required: true, message: '请选择工单类型', trigger: 'change' },
        ],
        Type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        WorkOrderDate: [
          { required: true, message: '请选择工单日期', trigger: 'change' },
        ],
        Amount: [
          { required: true, message: '请输入外委维修费用', trigger: 'blur' },
        ],
        FaultDescription: [
          { required: true, message: '请输入故障描述', trigger: 'blur' },
        ],
        Remarks: [
          { required: true, message: '请输入建议描述', trigger: 'blur' },
        ],
        // ExpectDate: [
        //   { required: true, message: "请选择预计完成日期", trigger: "change" },
        // ],
        OperatorIds: [
          { required: true, message: '请选择人员信息', trigger: 'change' },
        ],
        // InStorTime: [{ required: true, message: "请选择日期", trigger: "change" }],
      },
      drawer: false,
      disabled: false,
      row: {},
      activeNames: [],
      devInfo: {},
    }
  },
  props: {
    isLog: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SelectData,
    SelectDicValue,
    DevDialog,
    FittingsOut,
    AIDrawer,
    Supplier,
  },
  methods: {
    selectSup(arr) {
      this.$set(this.form, 'SupplierId', arr[0].Id)
      this.$set(this.form, 'SupplierName', arr[0].Name)
    },
    openSup() {
      this.$refs.Supplier.openDialog()
    },
    AISub(str) {
      this.$set(this.form, 'Remarks', str)
    },
    handleAvatarSuccess(res, file, fileList) {
      console.log(file, fileList)
      console.log(res)
      this.Imgs = [...fileList]
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
      this.Imgs = [...fileList]

      // this.Imgs = [...fileList];
    },
    handleExceed() {
      this.$notify.warning(`当前限制选择 9 个文件`)
    },
    handlePictureCardPreview(file) {
      window.open(file.url)
    },
    AIOpen() {
      console.log(111111111111)
      if (!this.form.DeviceItemId || !this.form.WorkOrderType) {
        return this.$notify.error('请选择设备与工单类型后再进行操作')
      }
      if (this.form.WorkOrderType === '2' || this.form.WorkOrderType === '3') {
        if (!this.form.FaultDescription) {
          return this.$notify.error('维修类型下请输入故障描述后进行操作')
        }
      }

      this.$refs.AIDrawer.open({ ...this.form })
    },
    NumChange(num, row) {
      console.log(num, row)
      if (!Number.isInteger(Number(num))) {
        this.$notify.error('数量不能为小数或负数')
        this.$set(row, 'Num', Math.floor(Number(num)))
      } else if (Number(num) < 0) {
        this.$notify.error('数量不能为小数或负数')
        this.$set(row, 'Num', 0)
      } else if (Number(num) > Number(row.Nums_N)) {
        this.$notify.error('数量不能超过库存数量')
        this.$set(row, 'Num', row.Nums_N)
      }
    },
    handleDevSelect(arr) {
      console.log(arr)
      this.$set(this.form, 'DeviceItemId', arr[0].Id)
      this.$set(this.form, 'DeviceItemName', arr[0].device_name)
      this.$set(this.form, 'DeviceItemCode', arr[0].DeviceCode)

      this.$set(
        this.form,
        'DeviceItemNameJson',
        `${this.form.DeviceItemName}(${this.form.DeviceItemCode})`
      )
    },
    handleAudit() {
      this.$confirm('是否提交工单？', {
        type: 'warning',
      }).then(() => {
        this.loading = true
        this.$http
          .post('/Base_DeviceTreeManage/Device_WorkOrder/SaveWorkOrderState', {
            Id: this.row.Id,
            State: '1',
          })
          .then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },

    selectFittingsOut(arr) {
      console.log(arr)
      if (this.MaterialsData.length == 0) {
        arr.forEach((item) => {
          this.MaterialsData.push({
            ...item,
            Num: '',
          })
        })
      } else {
        const duplicateIds = []
        arr.forEach((item) => {
          const exists = this.MaterialsData.some(
            (detail) => detail.MaterialId === item.MaterialId
          )
          if (exists) {
            duplicateIds.push(`备件名称:${item.Name},备件编号:${item.Code}`)
          } else {
            this.MaterialsData.push({
              ...item,
              Num: '',
            })
          }
        })
        if (duplicateIds.length > 0) {
          this.$notify.warning(
            `以下设备已存在，未重复添加: ${duplicateIds.join(', ')}`
          )
        }
      }
    },
    addList() {
      this.$refs.FittingsOut.openDialog()
    },

    openDevice() {
      this.$refs.DevDialog.openDialog()
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },

    getRoleList() {
      this.$http
        .post('/Base_Manage/Base_Role/GetDataList', {
          SortField: 'CreateTime',
          SortType: 'Desc',
        })
        .then((resJson) => {
          if (resJson.Success) {
            this.RoleList = resJson.Data
          }
        })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查*号必填项是否填入')
        }

        if (this.MaterialsData.length > 0) {
          let isNum = this.MaterialsData.every((item) => {
            return Number(item.Num) > 0
          })

          console.log(isNum, 'every')
          if (!isNum) {
            this.$notify.error('请输入备件数量')
            return
          }
        }
        const loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })

        // this.loading = true;
        let imgs = []
        if (this.Imgs.length > 0) {
          this.Imgs.forEach((item) => {
            imgs.push({
              name: item.name,
              url: item.response ? item.response.url : item.url || '',
              extname: item.extname
                ? item.extname
                : item.name.split('.')[item.name.split('.').length - 1],
            })
          })
        }
        this.$http
          .post('/Base_DeviceTreeManage/Device_WorkOrder/SaveWorkOrderData', {
            device_WorkOrder: {
              ...this.form,
              OperatorIds: this.form.OperatorIds.join(','),
            },
            device_WorkOrderItems: this.MaterialsData,
            device_WorkOrderDrawings: [...imgs],
          })
          .then((resJson) => {
            // this.loading = false;
            loading.close()
            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}, disabled = false, dev = {}, WorkOrderType = '') {
      this.drawer = true
      this.disabled = disabled
      // this.getRoleList();
      this.row = row
      this.Imgs = []
      this.activeNames = ['1', '2', '3']
      this.MaterialsData = []
      this.devInfo = dev
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.form = {
          Code: '',
          DeviceItemNameJson: dev.Id
            ? `${dev.device_name}(${dev.DeviceCode})`
            : '',
          DeviceItemId: dev.Id || '',
          DeviceItemName: dev.device_name || '',
          DeviceItemCode: dev.DeviceCode || '',
          WorkOrderType: WorkOrderType || '',
          Type: '',
          WorkOrderDate: moment().format('YYYY-MM-DD'),
          ExpectDate: '',
          FaultDescription: '',
          Remarks: '',
          OperatorIds: [],
          Amount: '',
          SupplierId: '',
          SupplierName: '',
        }
        console.log(this.form.WorkOrderType, 'form.WorkOrderType')
        setTimeout(() => {
          const addBtn = document.querySelector('.ql-addBtn')
          if (!addBtn) {
            return
          }
          addBtn.className = 'flex-juc-aic'

          addBtn.style = `width: 80px;height: 30px;line-height: 30px;text-align: center;color: #fff;background-color: #409eff;border-radius: 4px;cursor: pointer;padding:0;border-radius: 10px`
          addBtn.innerHTML = `<i class='el-icon-chat-dot-round'>AI建议</i>`
        }, 1)
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_WorkOrder/GetWorkOrderData', {
          id: id,
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            resJson.Data.device_WorkOrder.OperatorIds = resJson.Data
              .device_WorkOrder.OperatorIds
              ? resJson.Data.device_WorkOrder.OperatorIds.split(',')
              : []
            this.form = resJson.Data.device_WorkOrder
            this.$set(
              this.form,
              'DeviceItemNameJson',
              `${this.form.DeviceItemName}(${this.form.DeviceItemCode})`
            )
            this.MaterialsData = resJson.Data.device_WorkOrderItems || []
            this.Imgs = resJson.Data.device_WorkOrderDrawings || []
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  overflow-y: auto;
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
::v-deep .disabled-upload {
  .el-upload--picture-card {
    display: none;
  }
}
</style>
